import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';
import { provideHotToastConfig } from '@ngxpert/hot-toast';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([credentialsInterceptor])),
    provideHotToastConfig({
      position: 'top-right',
      duration: 3000,
      dismissible: true,
      stacking: 'vertical',
      visibleToasts: 5,
      closeStyle: {
        filter: 'invert(1)',
      },
      style: {
        background: '#575859',
        color: '#FFFFFF',
        fontFamily: "'Figtree', sans-serif",
        marginTop: '100px',
        fontSize: '14px',
        fontWeight: '500',
        borderRadius: '8px',
        padding: '12px 16px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)',
        minWidth: '280px',
      },
    }),
  ],
};
